import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useConfirm } from 'material-ui-confirm';
import { IconButton } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  useDeleteLogisticTasksMutation,
  usePauseLogisticTasksMutation,
  useStartLogisticTasksMutation,
  useStopLogisticTasksMutation,
} from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import Container from './styles/Container';

function LogisticTaskActionButtons({ logisticTask, sx }) {
  const { logisticTaskId, isRunnable, status, companyId } = logisticTask?.data || {};

  const isStopped = status === 'STOPPED';
  const isRunning = status === 'RUNNING';

  const navigate = useNavigate();

  const [pauseLogisticTasks] = usePauseLogisticTasksMutation();
  const [startLogisticTasks] = useStartLogisticTasksMutation();
  const [deleteLogisticTask] = useDeleteLogisticTasksMutation();
  const [stopLogisticTasks] = useStopLogisticTasksMutation();

  const confirm = useConfirm();

  const handleDelete = () => {
    confirm({
      title: 'Удалить?',
      confirmationText: 'Да',
      cancellationText: 'Отмена',
      description: `Вы действительно хотите удалить задачу?`,
    })
      .then(() => {
        deleteLogisticTask(logisticTaskId);
        navigate(`/companies/${companyId}/logistics`);
      })
      .catch(() => {});
  };

  const handleStart = () => {
    startLogisticTasks({ id: logisticTaskId });
  };

  const handleStop = () => {
    stopLogisticTasks({ id: logisticTaskId });
  };

  const handlePause = () => {
    pauseLogisticTasks({ id: logisticTaskId });
  };

  if (!isRunnable) return null;

  return (
    <Container sx={sx}>
      <IconButton disabled={isRunning} title="Старт" color="primary" onClick={handleStart}>
        <PlayCircleIcon />
      </IconButton>

      <IconButton disabled={isStopped || !isRunning} title="Стоп" color="primary" onClick={handleStop}>
        <DoDisturbIcon />
      </IconButton>

      <IconButton disabled title="Пауза" color="primary" onClick={handlePause}>
        <PauseIcon />
      </IconButton>

      <IconButton title="Удалить" color="primary" onClick={handleDelete}>
        <DeleteIcon />
      </IconButton>
    </Container>
  );
}

LogisticTaskActionButtons.propTypes = {
  logisticTask: PropTypes.shape({
    data: PropTypes.shape({
      logisticTaskId: PropTypes.number.isRequired,
      isRunnable: PropTypes.bool.isRequired,
    }),
  }),
  sx: PropTypes.shape(),
};

LogisticTaskActionButtons.defaultProps = {
  logisticTask: {},
  sx: {},
};

export default LogisticTaskActionButtons;
